import Layout from 'bento-ordering/base/layouts/BaseLayout';

import { CART_ITEM, CART_BASE } from 'bento-ordering/cart/constants/paths';
import EditCartItemModal from 'bento-ordering/cart/containers/EditCartItemModal';
import CartDrawer from 'bento-ordering/cart/containers/CartDrawer';

const routes = [
  {
    path: CART_BASE,
    exact: true,
    Component: CartDrawer,
    Layout
  },
  {
    path: CART_ITEM,
    exact: true,
    Component: EditCartItemModal,
    Layout
  }
];

export default routes;
